var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitedAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 52,
    height: 52,
    rx: 26
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.28 19.731c0-5.119 4.106-9.225 9.169-9.225 5.062 0 9.168 4.163 9.168 9.225 0 5.063-4.106 9.169-9.168 9.169a9.17 9.17 0 01-9.169-9.169zM26.45 30.7c8.438 0 15.3 6.863 15.3 15.3v4.894c-3.544 2.25-9.225 3.6-15.3 3.6-6.075 0-11.756-1.35-15.3-3.6V46c0-8.438 6.862-15.3 15.3-15.3z",
    fill: "#D9DFE4",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 52.8C11.751 52.8.2 41.249.2 27S11.751 1.2 26 1.2c7.896 0 15.207 3.57 20.075 9.593A25.691 25.691 0 0151.8 27c0 14.249-11.551 25.8-25.8 25.8zm0-1.6c13.365 0 24.2-10.835 24.2-24.2a24.092 24.092 0 00-5.369-15.201A24.148 24.148 0 0026 2.8C12.635 2.8 1.8 13.635 1.8 27c0 13.365 10.835 24.2 24.2 24.2z",
    fill: "#D9DFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 37,
    y: 4.4,
    width: 17,
    height: 17,
    rx: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.45 6.3c1.766 0 3.448.693 4.703 1.947a6.652 6.652 0 010 9.406 6.652 6.652 0 01-9.406 0A6.652 6.652 0 0145.45 6.3zm0 .919a5.708 5.708 0 00-4.049 1.682 5.72 5.72 0 000 8.098 5.72 5.72 0 008.098 0 5.72 5.72 0 000-8.098A5.708 5.708 0 0045.45 7.22zm-.55 5.857l-.003-.012-.008-.042a.388.388 0 01-.003-.128V8.462a.564.564 0 111.128-.005l-.03 4.228 2.854 2.853a.564.564 0 11-.79.805l-2.918-2.922-.022-.017h-.001l-.014-.013-.039-.034-.033-.036-.014-.018-.032-.044-.025-.045-.002-.005-.004-.01-.004-.008-.008-.017a.246.246 0 01-.017-.05c-.01-.026-.01-.026-.015-.048z",
    fill: "#D9DFE4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitedAvatar);
export default __webpack_public_path__ + "static/media/Invited_avatar.9b0420cad14e25435abaf0e7cb68b9cd.svg";
export { ForwardRef as ReactComponent };